import { SVGInterface } from "../../interface";

const PieChart = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 14L10 4.25203C6.54955 5.14012 4 8.27232 4 12C4 16.4183 7.58172 20 12 20C15.7277 20 18.8599 17.4505 19.748 14H10ZM22 12C22 12.6849 21.9311 13.3538 21.8 14C20.8734 18.5645 16.8379 22 12 22C6.47715 22 2 17.5228 2 12C2 7.16208 5.43552 3.12658 10 2.20004C10.6462 2.06886 11.3151 2 12 2L12 12H22Z"
      fill={color || "#0E171F"}
    />
    <path
      d="M14 2.20001C17.9183 2.99538 21.0046 6.08172 21.8 9.99998H19.748C19.0244 7.18876 16.8112 4.97557 14 4.25201V2.20001Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default PieChart;
